<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="/">Quiz-Boxing admin</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse v-if="isLoggedIn" id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="hasAdminRole" to="/client">Clients</b-nav-item>
          <b-nav-item v-if="hasAdminRole" to="/rooms">Salles</b-nav-item>
          <b-nav-item v-if="hasAdminRole" to="/users">Utilisateurs</b-nav-item>
          <b-nav-item v-if="hasAdminRole" to="/filesUpload"
            >Fichiers</b-nav-item
          >
          <b-nav-item v-if="hasAdminRole" to="/stats">Statistiques</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav v-if="hasAdminRole">
          <b-nav-item to="/client-stats">Stats pour client</b-nav-item>

          <b-nav-item-dropdown text="Textes" right>
            <b-dropdown-item to="/locales">Français</b-dropdown-item>
            <b-dropdown-item to="/locales/en">English</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav v-if="isLoggedIn" class="ml-auto">
          <b-nav-item>
            <button class="nav-link" @click.prevent="logout()">
              Déconnexion
            </button>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div v-if="!isProduction" class="env-banner">
      You are currently on the {{ envName.toUpperCase() }} environment
    </div>

    <router-view />

    <notifications position="top right" :duration="5000" />
  </div>
</template>

<script>
  import { useAuthStore } from '@/stores/auth'
  import { useConfigStore } from '@/stores/config'

  export default {
    computed: {
      isLoggedIn() {
        const authStore = useAuthStore()
        return authStore.isLoggedIn
      },
      isLoggedWithPassword() {
        return localStorage.getItem('ps') !== null
      },
      hasAdminRole() {
        const authStore = useAuthStore()
        return authStore.hasRole('admin')
      },
      hasContentManagerRole() {
        const authStore = useAuthStore()
        return authStore.hasRole('content-manager')
      },
      isProduction() {
        const configStore = useConfigStore()
        return configStore.isProduction
      },
      envName() {
        const configStore = useConfigStore()
        return configStore.envName
      },
      envPrefix() {
        const configStore = useConfigStore()
        return configStore.envPrefix
      },
    },
    watch: {
      $route: {
        handler() {
          this.updatePageTitle()
        },
      },
      envPrefix: {
        handler() {
          this.updatePageTitle()
        },
      },
    },
    methods: {
      logout() {
        const authStore = useAuthStore()
        authStore.logout()
        this.$router.push('/login')
      },
      updatePageTitle() {
        const pageTitles = {
          Login: 'Connexion',
          Clients: 'Clients',
          ClientNew: 'Nouveau client',
          Client: 'Client',
          Rooms: 'Salles',
          Users: 'Utilisateurs',
          Room: 'Salle',
          Logs: 'Logs',
          ContentManagerPage: 'Content',
          Questions: 'Questions',
          FilesPage: 'Fichiers',
          Locales: 'Textes FR',
          Statistiques: 'Statistiques',
          ClientStats: 'Stats Client',
          LocalesEnglish: 'Textes EN',
          FilesEnglish: 'Fichiers EN',
          Forbidden: 'Accès refusé',
          Rapport: 'Rapport',
        }
        const pageTitle = pageTitles[this.$route.name] || 'Quiz-Boxing'
        document.title = `${this.envPrefix}${pageTitle} - Quiz-Boxing Admin`
      },
    },
    async mounted() {
      const authStore = useAuthStore()
      authStore.initializeAuth()

      const configStore = useConfigStore()
      await configStore.loadConfig()
      this.updatePageTitle()
    },
  }
</script>

<style>
  button.nav-link {
    background-color: transparent;
    border: none;
  }
</style>
